import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentChatConversation, QueryIntentChatConversationsArgs } from "types/generated";

import { CHAT_CONVERSATION_BASIC_FRAGMENT } from "../gql";

type ChatConversationsData = {
  intentChatConversations: IntentChatConversation[];
};

export const CHAT_CONVERSATIONS: TypedDocumentNode<
  ChatConversationsData,
  QueryIntentChatConversationsArgs
> = gql`
  query ChatConversations($page: Int, $perPage: Int, $search: String) {
    intentChatConversations(page: $page, perPage: $perPage, search: $search) {
      ...ChatConversationBasic
    }
  }
  ${CHAT_CONVERSATION_BASIC_FRAGMENT}
`;
